import { useQuery } from 'react-query';

import { AuditTrailGetRequestDto } from '../../../../../backend/src/auditTrail/dto/auditTrail-get.request.dto';
import { AuditTrailGetResponseDto } from '../../../../../backend/src/auditTrail/dto/auditTrail-get.response.dto';
import { APIBaseChronos } from '@/api/hosts';
import { ApiError, QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

const useGetAuditTrail = ({ enabled, data }: { enabled: boolean; data: AuditTrailGetRequestDto }) => {
  const { getFetchConfig } = useGetFetchConfig();

  const fetchConfigPOST = getFetchConfig({
    method: FetchMethod.POST,
    data,
  });

  return useQuery<AuditTrailGetResponseDto, ApiError>(
    [
      QueryEntity.AuditTrail,
      data.startDate,
      data.endDate,
      data.matterId,
      data.userId,
      data.organisationId,
      data.auditEventType,
      data.page,
      data.pageSize,
      data.searchQuery,
      data.sortBy,
      data.sortDir,
    ],
    async () => {
      const response = await fetch(`${APIBaseChronos}/api/auditTrail`, {
        ...fetchConfigPOST,
      });
      if (!response.ok) throw new ApiError(response.status, 'Failed to fetch audit trail');
      return response.json();
    },
    { refetchOnWindowFocus: false, enabled, retry: false },
  );
};

export default useGetAuditTrail;
